import axios from "axios";

const timeout = 30000;

const doGetToken = (url) => {
  const method = 'GET';

  return axios({ url, method })
}

const doLogin = (url, data, params) => {
  const method = 'POST';
  // const headers = {'X-DEVICE': 'web'}

  return axios({ url, method, data, params, timeout });
}

const doGetSession = (url, token, data) => {
  const method = 'POST';
  const headers = { 'Authorization': token }

  return axios({url, method, headers, data})
}

const doGetMappingUser = (url, token) => {
  const method = 'GET';
  const headers = { 'Authorization': token }

  return axios({url, method, headers})
}

const doGet = (token, url, params) => {
  const method = 'GET';
  const headers = { 'Authorization': token }

  return axios({url, method, headers, params})
}

const doPost = (url, token, data, params) => {
  const method = 'POST'
  const headers = { 'Authorization': token }

  return axios({url, method, headers, data, params})
}

const doPut = (url, token, data) => {
  const method = 'PUT'
  const headers = {
    'Authorization': token 
  }

  return axios({url, method, headers, data})
}

const doDelete = (url, token, data, params) => {
  const method = 'DELETE'
  const headers = { 'Authorization': token }

  return axios({url, method, headers, data, params})
}

const doPWA = (url, data) => {
  const method = 'POST'

  return axios({ url, method, data })
}

const doExport = (url, token, payload) => {
  const method = 'POST'
  const headers = {
    'Authorization': token
  };
  const responseType = {
    responseType:  'arraybuffer'
  };

  return axios({ method, url, ...responseType, headers, data: payload });
}

export { doLogin, doDelete, doGet, doGetMappingUser, doGetSession, doPost, doPut, doGetToken, doPWA, doExport }